module.exports = __webpack_public_path__ + "static/media/staffimg2.c2937e94.png";